var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFacebookIcon = function SvgFacebookIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.5 0a17.5 17.5 0 1 0 0 35 17.5 17.5 0 0 0 0-35M23 10.575h-1.625a1.85 1.85 0 0 0-2.087 2.038v2.412h3.562l-.575 3.75h-2.987v8.975a12.5 12.5 0 0 1-4.026 0v-9.038H12v-3.75h3.262v-2.8a4.537 4.537 0 0 1 4.863-5q1.447.021 2.875.25z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFacebookIcon);
export default ForwardRef;